module.exports = __webpack_public_path__ + "img/logo2.805f8e46.png";